import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { checkIsActive } from '../../../../helpers/RouterHelpers'
import SAISVG from '../../../../helpers/CommonFunction'

const SidebarMenuItem = ({children,to,title,icon,fontIcon,hasBullet = false}) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)

    return (
        <div className='menu-item mb-2'>
            <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
                {hasBullet && (
                    <span className='menu-bullet'>
                        <span className='bullet bullet-dot'></span>
                    </span>
                )}
                {icon && (
                    <span className='menu-icon'>
                        {' '}
                        <SAISVG path={icon} className='svg-icon-2' />
                    </span>
                )}
                {fontIcon && (
                    <i className={clsx('bi fs-3', fontIcon)}></i>
                )}
                <span className='menu-title'>{title}</span>
            </Link>
            {children}
        </div>
    )
}

export default SidebarMenuItem;